import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import styles from './list-wrapper.module.css';

export function ListWrapper({ children }: PropsWithChildren<any>) {
    return (
        <div className={classNames(styles['list-wrapper'])}>{children}</div>
    );
}
